import Vue from 'vue'
import db from '@/umcc/db'
import ElementUI, { MessageBox, Message } from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(ElementUI, {
  size: 'mini',
  locale: db.lang === 'en' ? enLocale : zhLocale
})

Vue.prototype.$confirm = (msg, title, ops = {}) =>
  MessageBox.confirm(msg, title, {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    center: true,
    closeOnClickModal: false,
    ...ops
  })

Vue.prototype.$message = {
  success: (message) => {
    Message.success({
      message: message,
      duration: 5000,
      center: true
    })
  },
  warning: (message) => {
    Message.warning({
      message: message,
      duration: 5000,
      center: true
    })
  },
  error: (message) => {
    Message.error({
      message: message,
      duration: 20000,
      showClose: true,
      center: true
    })
  }
}
